import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { InquiryDetail } from '../InquiryDetail';
import { InquiryFilter } from './InquiryFilter';
import { InquiryTable } from './InquiryTable';

interface IProps {
  title?: string;
}

export const InquiryList: FC<IProps> = ({ title }) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <div className='flex flex-col gap-[16px] mx-auto w-full max-w-[1280px]'>
        <div className='flex justify-between'>
          <InquiryFilter />
          <div className='text-right'></div>
        </div>

        <InquiryTable />
      </div>
      <InquiryDetail />
    </>
  );
};
